
export default {
  name: 'BaseDataTable',
  props: {
    items: {
      type: Array,
      default() { return []; },
    },
    headers: {
      type: Array,
      default() { return []; },
    },
    itemsPerPage: {
      type: Number,
      default: 50,
    },
    customSortBy: {
      type: Array,
      default() { return []; },
    },
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      headersWithClass: this.headers,
      defaultProps: {
        calculateWidths: true,
        hideDefaultFooter: true,
      },
    };
  },
  watch: {
    headers(newHeaders) {
      this.headersWithClass = newHeaders;
    },
  },
  methods: {
    /* eslint-disable no-param-reassign */
    onSorting(name) {
      if (this.customSortBy.length) {
        this.headersWithClass.forEach((header) => {
          const isActive = this.customSortBy.includes(name) && header.value === name;
          header.class = isActive ? 'active-header' : '';
          header.cellClass = isActive ? 'active-cell' : '';
        });
      } else {
        this.headersWithClass.forEach((header) => {
          const isActive = header.value === name;
          header.class = isActive ? 'active-header' : '';
          header.cellClass = isActive ? 'active-cell' : '';
        });
      }
    },
    onSortingDesc(isDesc) {
      this.headersWithClass.forEach((header) => {
        const isActive = this.customSortBy.includes(header.value);
        if (isActive) header.decsending = isDesc;
        // header.class = isActive ? isDesc ? `${header.class} desc` : `${header.class} asc` : ''
      });
    },
    /* eslint-enable no-param-reassign */
  },
};
